import { useEffect, useState } from "react";

interface props {
  element1?: any;
  element2?: any;
  element3?: any;
}

const HeaderLayout = ({ element1, element2, element3 }: props) => {
  //width for mobile view
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {width < 768 ? (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {element1}
            {element2}
          </div>
          {element3}
        </>
      ) : (
        <>
          {element1}
          {element3}
          {element2}
        </>
      )}
    </>
  );
};

export default HeaderLayout;
